import { WaterMeterThresholdsPage } from "./WaterMeterThresholdsPage";

const WaterMeterThresholds = () => {
	return <WaterMeterThresholdsPage />;
};

export default WaterMeterThresholds;
